import { post } from "jquery";
import Swal from "sweetalert2";
const Genesis = require("../Genesis.js");
export class ISiteMobileDocumentFileListPage {
    constructor() {  }
    public Init() { 
      
    }    
};